import { useDataSubmit, useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnSubmit(props) {
  let submit = useDataSubmit({
    context: 'user_preferences',
    viewPath: props.viewPath,
  })
  return async function onSubmit(selected) {
    await submit({
      selected,
    })
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}

export function useOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })
  return function onChange(value) {
    if (Array.isArray(value)) {
      change(value)
    }
  }
}

export function useOnFilter(props) {
  return function onFilter(value, items) {
    let valueRegex = new RegExp(value, 'i')
    return items.filter(item => valueRegex.test(item.text))
  }
}

export function useOnValidateSubmit(props) {
  let filters = useDataValue({
    context: 'user_preferences',
    path: 'timeline_filter_presets',
    viewPath: props.viewPath,
  })
  let selected = useDataValue({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onValidateSubmit() {
    let original = new Set(
      filters.filter(item => item.value).map(item => item.id)
    )

    return (
      original.size !== selected.length ||
      selected.some(item => !original.has(item))
    )
  }
}
